import styled from 'styled-components';
import { ui } from './tokens';

// Solid gold and gold-outline buttons, matching the app's StepCard buttons
// (48px tall, 6px radius, Poppins Regular 16px).
const BaseButton = styled.button`
	height: 48px;
	border-radius: 6px;
	font-family: ${ui.font};
	font-size: 16px;
	font-weight: 400;
	cursor: pointer;
	flex: 1;
	padding: 0 12px;
	transition: opacity 0.15s, transform 0.1s;

	&:active:not(:disabled) {
		transform: scale(0.98);
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
`;

export const GoldButton = styled(BaseButton)`
	background-color: ${ui.gold};
	color: ${ui.onGold};
	border: none;
`;

export const OutlineButton = styled(BaseButton)`
	background-color: transparent;
	color: ${ui.gold};
	border: 1px solid ${ui.gold};
`;

export const ButtonRow = styled.div`
	display: flex;
	gap: 12px;
	margin-top: 24px;
`;
